import { useState } from 'react';
import { Link } from 'react-router-dom';
import home from "../../assets/theme-images/home.png";
import './Navbar.css';

const Navbar = () => {
    const [toggleMenu,
        setToggleMenu] = useState(false);
    const [isFixed,
        setIsFixed] = useState(false);

        
    const handleScroll = () => {
        if (window.scrollY > 100) {
            setIsFixed(true);
        } else {
            setIsFixed(false);
        }
    }

    return (
        <nav className="z-nav fixed w-full flex justify-center items-center text-[#C19B50] bg-white/100 max-h-12 sm:px-8 sm:py-4 shadow-md">
  <ul className="flex space-x-6 text-lg font-semibold">
    <li>
      <Link to="/" className="hover:opacity-80 transition-opacity duration-300">
        <img src={home} alt="Inicio" className="h-12 w-auto" />
    </Link>
    </li>
    {/* Puedes añadir más elementos aquí si lo necesitas */}
  </ul>
</nav>

    );
};

export default Navbar;
